import { useState, useRef, useEffect, useCallback, type Dispatch, type SetStateAction } from "react";
import businessPartnersIcon from "../../assets/images/business-partners-greyscale.b597e6fe.svg";
import overviewIcon from "../../assets/images/overview-greyscale.8e44ee66.svg";
import { ChevronRight } from "../../assets/svg";
const iconMap: Record<string, string> = {
  "/images/business-partners-greyscale.b597e6fe.svg": businessPartnersIcon,
  "/images/overview-greyscale.8e44ee66.svg": overviewIcon,
};

export interface NavItemProps {
  navItem: {
    title: string;
    description?: string;
    link: string;
    top_header?: boolean;
    header?: boolean;
    login?: boolean;
    icon?: string;
    sub_nav: {
      title: string;
      link: string;
      sub_nav_2: {
        title: string;
        link: string;
      }[];
    }[];
  }[];
  setShowHeaderAlertContent: (showHeaderAlertContent: boolean) => void;
  showHeaderAlertContent: boolean;
  setShowSiteSearch: (showSiteSearch: boolean) => void;
  showSiteSearch: boolean;
  hasMaintenanceMsg: boolean;
  isAuth: boolean;
  handleOnClick: () => void;
  isNarrowViewport: boolean;
  isHidden: boolean;
  setIsHidden: Dispatch<SetStateAction<boolean>>;
  /** When true, mobile submenu is open — hide fixed SearchSG strip + panel top padding */
  hideMobileNavSearch: boolean;
  setHideMobileNavSearch: Dispatch<SetStateAction<boolean>>;
}

function NavItemV2({ navItem, setShowHeaderAlertContent, showHeaderAlertContent, setShowSiteSearch, showSiteSearch, hasMaintenanceMsg, isAuth, handleOnClick, isNarrowViewport, isHidden, setIsHidden, hideMobileNavSearch, setHideMobileNavSearch }: NavItemProps) {
  const topHeaderItems = navItem.filter(item => item.top_header === true && item.login !== true);
  const bottomHeaderItems = navItem.filter(item => item.header === true);
  const loginItems = navItem.filter(item => item.login === true);

  useEffect(() => {
    if (!isNarrowViewport) {
      document.body.style.overflow = "";
      return;
    }
    if (!isHidden) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isNarrowViewport, isHidden]);

  return (
    isNarrowViewport ? 
    (
      <div>
        <ul className="old-header-primary-nav old-header-primary-nav-top">
          {loginItems.length > 0 && <LoginButton loginItems={loginItems} isAuth={isAuth} handleOnClick={handleOnClick} />}
          <li className="polymer-nav-item">
            <button
              type="button"
              className="polymer-nav-item-button"
              aria-expanded={isHidden}
              aria-label={isHidden ? "Show main content" : "Hide main content"}
              onClick={() =>
                setIsHidden((prev) => {
                  if (!prev) setShowSiteSearch(false);
                  return !prev;
                })
              }
            >
              {isHidden ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="tabler-icon tabler-icon-x text-primary-600"
                  aria-hidden
                >
                  <path d="M18 6l-12 12" />
                  <path d="M6 6l12 12" />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="tabler-icon tabler-icon-menu-2"
                  aria-hidden
                >
                  <path d="M4 6l16 0" />
                  <path d="M4 12l16 0" />
                  <path d="M4 18l16 0" />
                </svg>
              )}
            </button>
          </li>
        </ul>
            {isHidden && (
          <div
            className={`polymer-nav-mobile-dropdown-panel${!hideMobileNavSearch ? " polymer-nav-mobile-dropdown-panel--has-global-search" : ""}`}
            role="dialog"
            aria-modal="true"
            aria-label="Main navigation"
          >
            <MobileSlidingNav
              bottomHeaderItems={bottomHeaderItems}
              topHeaderItems={topHeaderItems}
              showHeaderAlertContent={showHeaderAlertContent}
              onNavigate={() => setIsHidden(false)}
              setShowHeaderAlertContent={setShowHeaderAlertContent}
              onDrillDepthChange={setHideMobileNavSearch}
            />
          </div>
        )}
      </div>
    ) : (
    <div>
      {topHeaderItems.length > 0 && (
        <ul className="old-header-primary-nav old-header-primary-nav-top">
          {topHeaderItems.map((item, _index: number) => {
            const key = `top_header_${_index}_${item.title}`;
            return <NavItemDropdown key={key} item={item} showDropdown={false} />;
          })}
          <li className="polymer-nav-item">
            <button className="polymer-nav-item-button" onClick={()=>{setShowHeaderAlertContent(!showHeaderAlertContent)}}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-bell"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6" /><path d="M9 17v1a3 3 0 0 0 6 0v-1" /></svg>
            </button>
          </li>
          <li className="polymer-nav-item">
            <button
              type="button"
              className="polymer-nav-item-button"
              aria-expanded={showSiteSearch}
              aria-label={showSiteSearch ? "Close site search" : "Open site search"}
              onClick={() => setShowSiteSearch(!showSiteSearch)}
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-search"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" /><path d="M21 21l-6 -6" /></svg></button>
          </li>
          {loginItems.length > 0 && <LoginButton loginItems={loginItems} isAuth={isAuth} handleOnClick={handleOnClick} />}
        </ul>
      )}
      {bottomHeaderItems.length > 0 && (
        <ul className="old-header-primary-nav old-header-primary-nav-bottom">
          {bottomHeaderItems.map((item, _index: number) => {
            const key = `header_${_index}_${item.title}`;
            return <NavItemDropdown key={key} item={item} showDropdown={true} showHeaderAlertContent={showHeaderAlertContent} />;
          })}
        </ul>
      )}
    </div>
  )
)}

type NavItemRow = NavItemProps["navItem"][0];
type SubNavEntry = NavItemRow["sub_nav"][number];

type MobileNavPanel =
  | { type: "root" }
  | { type: "main"; item: NavItemRow }
  | { type: "sub"; item: NavItemRow; sub: SubNavEntry };

function MobileNavBackHeader({ title, onBack }: { title: string; onBack: () => void }) {
  return (
    <div className="polymer-nav-mobile-panel__back">
      <button type="button" className="polymer-nav-mobile-panel__back-btn" onClick={onBack}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="polymer-nav-mobile-panel__back-icon"
          aria-hidden
        >
          <path d="M15 6l-6 6l6 6" />
        </svg>
        <span className="polymer-nav-mobile-panel__back-title">{title}</span>
      </button>
    </div>
  );
}

function MobileSlidingNav({
  bottomHeaderItems,
  topHeaderItems,
  showHeaderAlertContent,
  onNavigate,
  setShowHeaderAlertContent,
  onDrillDepthChange,
}: {
  bottomHeaderItems: NavItemRow[];
  topHeaderItems: NavItemRow[];
  showHeaderAlertContent: boolean;
  onNavigate: () => void;
  setShowHeaderAlertContent: (v: boolean) => void;
  onDrillDepthChange?: (hideSearch: boolean) => void;
}) {
  const [stack, setStack] = useState<MobileNavPanel[]>([{ type: "root" }]);

  useEffect(() => {
    onDrillDepthChange?.(stack.length > 1);
  }, [stack, onDrillDepthChange]);

  const push = useCallback((panel: MobileNavPanel) => {
    setStack((s) => [...s, panel]);
  }, []);

  const pop = useCallback(() => {
    setStack((s) => (s.length > 1 ? s.slice(0, -1) : s));
  }, []);

  const depth = stack.length - 1;
  const n = stack.length;
  const translatePct = n > 0 ? (depth / n) * 100 : 0;

  const panelKey = (panel: MobileNavPanel, i: number) => {
    if (panel.type === "root") return "root";
    if (panel.type === "main") return `main-${panel.item.link}`;
    return `sub-${panel.item.link}-${panel.sub.link}-${i}`;
  };

  return (
    <nav className="polymer-nav-mobile-overlay__nav polymer-nav-mobile-overlay__nav--panels" aria-label="Site sections">
      <div className="polymer-nav-mobile-panels-viewport">
        <div
          className="polymer-nav-mobile-panels-track"
          style={{
            width: `${n * 100}%`,
            transform: `translateX(-${translatePct}%)`,
          }}
        >
          {stack.map((panel, index) => (
            <div
              key={panelKey(panel, index)}
              className="polymer-nav-mobile-panel"
              style={{ width: `${100 / n}%` }}
            >
              {panel.type === "root" && (
                <ul className="polymer-nav-mobile-dropdown__list">
                  {bottomHeaderItems.map((item, _index) => {
                    const hasSub = item.sub_nav && item.sub_nav.length > 0;
                    const key = `header_${_index}_${item.title}`;
                    if (!hasSub) {
                      return (
                        <li key={key} className="polymer-nav-mobile-dropdown__item">
                          <a href={item.link} className="polymer-nav-mobile-dropdown__link" onClick={onNavigate}>
                            {item.title}
                          </a>
                        </li>
                      );
                    }
                    return (
                      <li key={key} className="polymer-nav-mobile-dropdown__item polymer-nav-mobile-dropdown__item--expandable">
                        <div className="polymer-nav-mobile-dropdown__row">
                          <a href={item.link} className="polymer-nav-mobile-dropdown__link" onClick={onNavigate}>
                            {item.title}
                          </a>
                          <button
                            type="button"
                            className="polymer-nav-mobile-dropdown__chevron"
                            aria-label={`Open ${item.title} submenu`}
                            onClick={() => push({ type: "main", item })}
                          >
                            <ChevronRight />
                          </button>
                        </div>
                      </li>
                    );
                  })}
                  {topHeaderItems.map((item, _index) => (
                    <li key={`mobile_top_${_index}_${item.link}`} className="polymer-nav-mobile-dropdown__item">
                      <a href={item.link} className="polymer-nav-mobile-dropdown__link" onClick={onNavigate}>
                        {item.title}
                      </a>
                    </li>
                  ))}
                  <li className="polymer-nav-mobile-dropdown__item">
                    <button
                      type="button"
                      className="polymer-nav-mobile-dropdown__link polymer-nav-mobile-dropdown__link--advisory"
                      onClick={() => setShowHeaderAlertContent(!showHeaderAlertContent)}
                    >
                      Advisory Messages
                      <div className="polymer-nav-mobile-dropdown__advisory-icon-container">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="polymer-nav-mobile-dropdown__advisory-icon"
                          aria-hidden
                        >
                          <path d="M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6" />
                          <path d="M9 17v1a3 3 0 0 0 6 0v-1" />
                        </svg>
                      </div>
                    </button>
                  </li>
                </ul>
              )}

              {panel.type === "main" && (
                <>
                  <MobileNavBackHeader title={panel.item.title} onBack={pop} />
                  <ul className="polymer-nav-mobile-dropdown__list polymer-nav-mobile-dropdown__sublist">
                    {panel.item.sub_nav!.map((sub) => {
                      const hasSub2 = sub.sub_nav_2 && sub.sub_nav_2.length > 0;
                      if (!hasSub2) {
                        return (
                          <li key={sub.link} className="polymer-nav-mobile-dropdown__item">
                            <div className="polymer-nav-mobile-dropdown__row">
                              <a href={sub.link} className="polymer-nav-mobile-dropdown__sublink" onClick={onNavigate}>
                                {sub.title}
                              </a>
                            </div>
                          </li>
                        );
                      }
                      return (
                        <li key={sub.link} className="polymer-nav-mobile-dropdown__item polymer-nav-mobile-dropdown__item--expandable">
                          <div className="polymer-nav-mobile-dropdown__row">
                            <a href={sub.link} className="polymer-nav-mobile-dropdown__sublink" onClick={onNavigate}>
                              {sub.title}
                            </a>
                            <button
                              type="button"
                              className="polymer-nav-mobile-dropdown__chevron"
                              aria-label={`Open ${sub.title} submenu`}
                              onClick={() => push({ type: "sub", item: panel.item, sub })}
                            >
                              <ChevronRight />
                            </button>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </>
              )}

              {panel.type === "sub" && (
                <>
                  <MobileNavBackHeader title={panel.sub.title} onBack={pop} />
                  <ul className="polymer-nav-mobile-dropdown__list polymer-nav-mobile-dropdown__sublist polymer-nav-mobile-dropdown__sublist--nested">
                    {panel.sub.sub_nav_2!.map((s2) => (
                      <li key={s2.link} className="polymer-nav-mobile-dropdown__item">
                        <a href={s2.link} className="polymer-nav-mobile-dropdown__sublink" onClick={onNavigate}>
                          {s2.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </nav>
  );
}

function NavItemDropdown({ item, showDropdown: showDropdownProp = false, showHeaderAlertContent = false }: { item: NavItemProps["navItem"][0]; showDropdown?: boolean; showHeaderAlertContent?: boolean }) {
  const { title, link, sub_nav } = item;
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeSubNav2Index, setActiveSubNav2Index] = useState<number | null>(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const navItemRef = useRef<HTMLLIElement>(null);

  const hasDropdown = showDropdownProp && sub_nav && sub_nav.length > 0;
  const keepDropdownInDom = hasDropdown && (isHovered || isClosing);
  const isVisible = isHovered; // opacity 1 only when hovered; when closing, opacity 0

  useEffect(() => {
    setActiveIndex(0);
  }, []);

  useEffect(() => {
    const updateDropdownPosition = () => {
      if (navItemRef.current && dropdownRef.current) {
        const rect = navItemRef.current.getBoundingClientRect();
        dropdownRef.current.style.top = `${rect.bottom}px`;
      }
    };

    updateDropdownPosition();
    window.addEventListener('scroll', updateDropdownPosition);
    window.addEventListener('resize', updateDropdownPosition);

    return () => {
      window.removeEventListener('scroll', updateDropdownPosition);
      window.removeEventListener('resize', updateDropdownPosition);
    };
  }, [showHeaderAlertContent, keepDropdownInDom]);

  useEffect(() => {
    const dropdown = dropdownRef.current;
    if (!dropdown || !isClosing) return;

    const handleTransitionEnd = (e: TransitionEvent) => {
      if (e.propertyName === 'opacity') {
        setIsClosing(false);
      }
    };

    dropdown.addEventListener('transitionend', handleTransitionEnd);
    return () => dropdown.removeEventListener('transitionend', handleTransitionEnd);
  }, [isClosing]);

  const handleLiMouseEnter = () => {
    setIsClosing(false);
    setIsHovered(true);
  };

  const handleLiMouseLeave = () => {
    if (isHovered && hasDropdown) {
      setIsHovered(false);
      setIsClosing(true);
    }
  };

  const handleMouseEnter = (index: number) => {
    setActiveIndex(index);
    setActiveSubNav2Index(null);
  };

  const handleSubNav2MouseEnter = (index: number) => {
    setActiveSubNav2Index(index);
  };

  const handleSubNav2MouseLeave = () => {
    setActiveSubNav2Index(null);
  };

  return (
    <li
      className="polymer-nav-item"
      ref={navItemRef}
      onMouseEnter={handleLiMouseEnter}
      onMouseLeave={handleLiMouseLeave}
    >
      <a href={link} className="polymer-nav-item-title">{title}</a>
      {keepDropdownInDom && (
      <div
        className={`polymer-nav-item-dropdown ${isVisible ? 'polymer-nav-item-dropdown-visible' : 'polymer-nav-item-dropdown-closing'}`}
        ref={dropdownRef}
        style={{ pointerEvents: isVisible ? 'auto' : 'none' }}
      >
          <div className="polymer-nav-item-dropdown-content-wrapper" ref={containerRef}>
            <div className="polymer-nav-item-dropdown-description-container">
              {sub_nav.map((subNavItem, subNavIndex) => (
                <div 
                  key={`subnav_${subNavItem.link}`} 
                  className="polymer-nav-item-dropdown-subnav-group" 
                  data-subnav-index={subNavIndex}
                  onMouseEnter={() => handleMouseEnter(subNavIndex)}
                >
                  <a 
                    href={subNavItem.link} 
                    className={`polymer-nav-item-dropdown-title ${activeIndex === subNavIndex ? 'polymer-nav-item-dropdown-title-active' : ''}`}
                  >
                    {subNavItem.title}
                  </a>
                </div>
              ))}
            </div>
            <div className="polymer-nav-item-dropdown-subnav-container">
              {sub_nav.map((subNavItem, subNavIndex) => (
                <ul 
                  key={`subnav-list-${subNavIndex}`} 
                  className={`polymer-nav-item-dropdown-subnav`} 
                  data-subnav-index={subNavIndex}
                  style={{ display: activeIndex === subNavIndex ? "grid" : "none" }}
                >
                  {subNavItem.sub_nav_2 && subNavItem.sub_nav_2.length > 0 ? (
                    subNavItem.sub_nav_2.map((subNav2Item, subNav2Index) => (
                      <li 
                        key={`subnav2_${subNav2Item.link}`} 
                        className={`polymer-nav-item-dropdown-subnav-item ${activeSubNav2Index === subNav2Index ? 'polymer-nav-item-dropdown-subnav-item-active' : ''}`}
                        onMouseEnter={() => handleSubNav2MouseEnter(subNav2Index)}
                        onMouseLeave={handleSubNav2MouseLeave}
                      >
                        <a className="polymer-nav-item-dropdown-subnav-link" href={subNav2Item.link} title={subNav2Item.title}>{subNav2Item.title}</a>
                      </li>
                    ))
                  ) : (
                    <li className="polymer-nav-item-dropdown-subnav-item">
                      <a className="polymer-nav-item-dropdown-subnav-link" href={subNavItem.link} title={subNavItem.title}>{subNavItem.title}</a>
                    </li>
                  )}
                </ul>
              ))}
            </div>
          </div>
      </div>
      )}
    </li>
  );
}

function LoginButton({
  loginItems,
  isAuth,
  handleOnClick,
  asListItem = true,
}: {
  loginItems: NavItemProps["navItem"];
  isAuth: boolean;
  handleOnClick: () => void;
  asListItem?: boolean;
}) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      if (
        dropdownRef.current && 
        !dropdownRef.current.contains(target) &&
        buttonRef.current &&
        !buttonRef.current.contains(target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    setIsLoggedIn(isAuth);
    setIsOpen(false);
  }, [isAuth]);

  useEffect(() => {
    setIsLoggedIn(isAuth);
    setIsOpen(false);
  }, [isAuth]);

  const wrapperClass = asListItem
    ? "polymer-nav-item polymer-nav-item-login"
    : "polymer-nav-item-login polymer-nav-item-login--overlay";

  const inner = (
    <>
      {!isLoggedIn ? 
      <button 
        ref={buttonRef}
        className="polymer-nav-item-login-button"
        onClick={(e) => { 
          e.preventDefault(); 
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-lock" style={{ marginRight: '8px' }}><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z" /><path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0" /><path d="M8 11v-4a4 4 0 1 1 8 0v4" /></svg>
        Login
      </button>
       : <button 
       ref={buttonRef}
       className="polymer-nav-item-login-button"
       onClick={(e) => { 
         e.preventDefault(); 
         e.stopPropagation();
         handleOnClick();
       }}
     >
       <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-lock" style={{ marginRight: '8px' }}><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z" /><path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0" /><path d="M8 11v-4a4 4 0 1 1 8 0v4" /></svg>
       Logout
     </button>}
      {isOpen && (
        <div className="polymer-nav-item-login-dropdown" ref={dropdownRef}>
          {loginItems.map((item, index:number) => (
            <>
              <a 
                key={`login_${index}_${item.title}`}
                href={item.link}
                className="polymer-nav-item-login-dropdown-item"
              >
                {item.icon && (
                  <img alt="" aria-hidden="true" loading="lazy" width="32" height="32" decoding="async" src={iconMap[item.icon] || item.icon} className="polymer-nav-item-login-dropdown-item-icon" />
                )}
                {item.title}
              </a>
              {index == 0 && <div className="polymer-nav-item-login-dropdown-separator" />}
            </>
          ))}
        </div>
      )}
    </>
  );

  return asListItem ? <li className={wrapperClass}>{inner}</li> : <div className={wrapperClass}>{inner}</div>;
}

export default NavItemV2;